export const notificationConstants = {
    GET_LIST_REQUEST: "GET_LIST_REQUEST",
    GET_LIST_SUCCESS: "GET_LIST_SUCCESS",
    GET_LIST_ERROR: "GET_LIST_ERROR",
    GET_LIST_UNREAD_SUCCESS: "GET_LIST_UNREAD_SUCCESS",
    GET_LIST_UNREAD_ERROR: "GET_LIST_UNREAD_ERROR"
}